'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Iconify } from '@/components/atoms/Iconify';
import { useCountdown } from '@/hooks/useCountdown';
import { formatNumber } from '@/libs/format';
import { useCountdownTimer } from '@/shared/hooks/useCountdownTimer';
import { isAuctionStarted } from '../helpers';
import { BaseExperienceCard } from './BaseExperienceCard';
import { ExperienceFavoriteButton } from './ExperienceFavoriteButton';
import type { ExperienceCardProps } from './types';
export const ExperienceCard = t0 => {
  const $ = _c(37);
  const {
    ee_name,
    ee_img,
    is_in_favorites,
    id,
    auction,
    views,
    myLastBid,
    myBidStatus,
    celebrity: t1,
    countdownTimer
  } = t0;
  const {
    first_name,
    last_name
  } = t1;
  let t2;
  if ($[0] !== auction) {
    t2 = isAuctionStarted(auction);
    $[0] = auction;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isAucStarted = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      showSeconds: false,
      updateIntervalSeconds: 60
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    text,
    isEnd
  } = useCountdown(isAucStarted ? auction?.finish_date_time : auction?.start_date_time, t3);
  useTranslations("experiences");
  const tTimer = useTranslations("timer");
  let t4;
  if ($[3] !== isAucStarted) {
    t4 = {
      isStarted: isAucStarted
    };
    $[3] = isAucStarted;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const countdown = useCountdownTimer(countdownTimer ? isAucStarted ? auction?.finish_date_time : auction?.start_date_time : null, t4);
  let t5;
  if ($[5] !== first_name || $[6] !== last_name) {
    t5 = {
      first_name,
      last_name
    };
    $[5] = first_name;
    $[6] = last_name;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== views) {
    t6 = views && views > 0 ? <div className="flex h-fit items-center gap-1 rounded-[16px] bg-[#1A1B2A99] px-2 py-1 text-[14px] font-semibold  leading-[130%] text-[#EBECFE]"><Iconify icon="mdi:eye" className="h-4 w-4" />{formatNumber(views)}</div> : <div className="flex  h-fit  items-center gap-1 rounded-[16px] bg-[#1A1B2A99] px-2 py-1 text-[14px] font-semibold leading-[130%]  text-[#EBECFE] opacity-0" />;
    $[8] = views;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== id || $[11] !== is_in_favorites) {
    t7 = <ExperienceFavoriteButton id={id} is_in_favorites={is_in_favorites} className="mr-2 mt-2" />;
    $[10] = id;
    $[11] = is_in_favorites;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="flex w-full items-center justify-between pl-2 ">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== countdown || $[17] !== countdownTimer || $[18] !== isAucStarted || $[19] !== isEnd || $[20] !== tTimer || $[21] !== text) {
    t9 = countdownTimer ? <div className="flex h-[44px] w-full items-center justify-center gap-1 rounded-full bg-[#1A1B2A99] px-2 py-1 text-[16px] font-semibold leading-[130%] text-[#EBECFE] backdrop-blur-[4px] md:h-fit md:px-4 md:py-3 md:text-[16px]">{countdown}</div> : !isEnd && <div className="flex h-[44px] w-full items-center justify-center gap-1 rounded-full bg-[#1A1B2A99] px-2 py-1 text-[16px] font-semibold leading-[130%] text-[#EBECFE] backdrop-blur-[4px] md:h-fit md:px-4 md:py-3 md:text-[16px]">{!isAucStarted ? tTimer("startsIn") : tTimer("endsIn")} {text}</div>;
    $[16] = countdown;
    $[17] = countdownTimer;
    $[18] = isAucStarted;
    $[19] = isEnd;
    $[20] = tTimer;
    $[21] = text;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <div className="flex w-full items-center justify-center gap-2 px-2 pb-2">{t9}</div>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8) {
    t11 = {
      top: t8,
      bottom: t10
    };
    $[25] = t10;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== auction || $[29] !== ee_img || $[30] !== ee_name || $[31] !== id || $[32] !== myBidStatus || $[33] !== myLastBid || $[34] !== t11 || $[35] !== t5) {
    t12 = <BaseExperienceCard ee_name={ee_name} ee_img={ee_img} id={id} auction={auction} myLastBid={myLastBid} myBidStatus={myBidStatus} celebrity={t5} slots={t11} />;
    $[28] = auction;
    $[29] = ee_img;
    $[30] = ee_name;
    $[31] = id;
    $[32] = myBidStatus;
    $[33] = myLastBid;
    $[34] = t11;
    $[35] = t5;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};